module.exports = __webpack_public_path__ + "img/Beginner-5.a221d954.png";